import { Pipe, PipeTransform } from '@angular/core';
import { Utils } from '../utils.class';

@Pipe({
    name: 'shortNumber',
    standalone: true,
})
export class ShortNumberPipe implements PipeTransform {
    transform(transformNumber: number, withDecimals = false) {
        if (isNaN(transformNumber)) {
            return transformNumber; // Return as is if not a number
        }

        return Utils.shortNumber(transformNumber, withDecimals);
    }
}
